import React from 'react';
import PropTypes from 'prop-types';
import {ExpandingBlurb} from '../../';

export default class ModSection extends React.PureComponent {
    static propTypes = {
        active: PropTypes.bool,
        modsData: PropTypes.object
    };

    render() {
        const {active, modsData} = this.props;
        const contentStyle = active ? 'content top active' : 'content not-visible';
        const links = [];
        const modLinks = modsData.linkList || [];
        for (const item of modLinks) {
            const {textOne, textTwo, link} = item;
            const key = `${item.textOne}-item`;
            links.push(
                <a
                    key={key} href={link} target="_blank" rel="noopener noreferrer"
                    className="box">
                    <h3>{textOne}</h3>
                    <h5>{textTwo}</h5>
                </a>
            );
        }
        return (
            <div id="modSection" className="section">
                <div className={contentStyle}>
                    <h1>{modsData.title}</h1>
                </div>
                <div className={this.props.active ? 'boxes active' : 'boxes not-visible'}>
                    {links}
                </div>
                <ExpandingBlurb
                    htmlText={modsData.descript || ''}
                    position="top"
                    active={this.props.active} />
            </div>
        );
    }
}
